import { Link } from 'react-router-dom';
import { useState } from 'react';
import FilmCard from '@/components/base/FilmCard';
import { films } from '@/mocks/films';

const tabs = [
  { key: 'movie', label: '电影推荐' },
  { key: 'tv', label: '剧集推荐' },
] as const;

export default function FeaturedSection() {
  const [active, setActive] = useState<(typeof tabs)[number]['key']>('movie');

  const list = films
    .filter((film) => film.type === active)
    .sort((a, b) => b.rating - a.rating || b.popularity - a.popularity)
    .slice(0, 6);

  return (
    <section>
      <div className="mb-4 flex flex-wrap items-end justify-between gap-3">
        <div>
          <p className="font-label text-[11px] uppercase tracking-[0.2em] text-accent-600">Editor&apos;s Picks</p>
          <h2 className="mt-1 font-heading text-xl font-bold text-foreground-950 md:text-2xl">精选推荐</h2>
        </div>
        <div className="flex items-center gap-2">
          <div className="flex rounded-full bg-background-200 p-1">
            {tabs.map((tab) => (
              <button
                key={tab.key}
                type="button"
                onClick={() => setActive(tab.key)}
                className={`rounded-full px-3.5 py-1.5 text-xs font-medium transition-colors cursor-pointer whitespace-nowrap ${
                  active === tab.key
                    ? 'bg-background-50 text-foreground-950'
                    : 'text-foreground-600 hover:text-foreground-900'
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>
          <Link
            to={`/category/${active}`}
            className="hidden sm:inline-flex items-center gap-1 text-xs font-medium text-foreground-600 transition-colors hover:text-accent-600 cursor-pointer whitespace-nowrap"
          >
            全部
            <i className="ri-arrow-right-s-line w-3.5 h-3.5 flex items-center justify-center" />
          </Link>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-4 lg:grid-cols-6">
        {list.map((film) => (
          <FilmCard key={film.id} film={film} />
        ))}
      </div>
    </section>
  );
}